<template>
    <div>
      <b-row>
        <b-col>
          <md-field>
            <label>{{$t('Type to Search')}}</label>
            <md-input v-model="filter" @update="filterChanged" @keypress="currentPage = 1"></md-input>
          </md-field>
        </b-col>
      </b-row>

      <basic-table
        v-if="freeIP"
        :items="items"
        :fields="freeIPFields"
        :filter="filter"
        :perPage="perPage"
        :currentPage="currentPage"
        @Filtred="Filtred"
        @ClickOnEditButton="onRowDoubleClick"
        isEdit="false"
        isDelete="false"/>
      <table-manager-bottom
        :totalRows="totalRows" :perPage="perPage"
        v-model="currentPage"/>
    </div>
  </template>

<script>
export default {
  props: {
    userInfo: null,
    isV4: true
  },
  data () {
    return {
      items: [],
      selectedfreeIP: null,
      freeIPFields: [
        {key: 'ip_address',
          label: 'IP',
          sortable: true,
          formatter: (val, key, item) => {
            return item.ip_address + '/' + item.mask.toString()
          }},
        {key: 'zone_name', label: this.$i18n.t('Zone'), sortable: true}
      ],
      options: {
        isShowAddButton: false
      },
      filter: null,
      perPage: 50,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    Filtred (items) {
      this.totalRows = items.length
    },
    onRowDoubleClick (item, index, event) {
      this.$emit('IPselected', item)
      this.$emit('hideFormfreeIP')
    },
    hideFormfreeIP () {
      this.$emit('hideFormfreeIP')
    },
    filterChanged (value) {
      this.filter = value
      this.currentPage = 1
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  watch: {
    freeIP: function (val) {
      this.totalRows = this.items.length
    }
  },
  mounted () {
    for (let el of this.freeIP) {
      if (this.isV4 && el.mask <= 32) {
        this.items.push(el)
      }
      if (!this.isV4 && el.mask > 32) {
        this.items.push(el)
      }
    }
    this.totalRows = this.items.length
  },
  computed: {
    freeIP () {
      return this.$store.getters['ReferenceBooks/FREE_IPS_OF_BUILDING']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/serviceLinks/formas/formFreeIp.vue